export const theme = {
	errorMessage: {
		borderTop: '',
		paddingLeft: '',
		fontSize: '',
		paddingTop: '',
	},
};
